import { clsx } from "clsx"
import { twMerge } from "tailwind-merge";
import { IndexedDBService } from "../../../services/indexedDbService";

const indexedDbService = new IndexedDBService();

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}


export async function validateIsAuthenticated() {
    let idIsAuthenticated = 'isAuthenticated';
    let item = await indexedDbService.findItem('id', idIsAuthenticated);
    if (item?.isAuthenticated && item.isAuthenticated === true) {
        return true;
    } else {
        return false;
    }

}
